import Themeable from "vuetify/lib/mixins/themeable";
import { Department } from "kinnect-models";
import { KSelectWithAll } from "kinnect-general";
import { FetchesData } from "kinnect-mixins";
import { VChip } from "vuetify/lib";

export default {
	name: "KCalendarDepartmentFilter",

	mixins: [
		FetchesData,
		Themeable
	],

	props: {
		maxChips: {
			default: 2,
			type: Number
		}
	},

	data: () => ( {
		departments: [],
		idsSelectedDepartments: []
	} ),

	computed: {
		authUserId() {
			return this.$store.getters["auth/userID"];
		},

		localStorageKeyName() {
			return `${this.$options.name}-${this.authUserId}`;
		},

		selectedDepartments() {
			return this.departments.filter( department =>
				this.idsSelectedDepartments.indexOf( department.id ) !== -1
			);
		},

		numHiddenChips() {
			return this.selectedDepartments.length - this.maxChips;
		},

		idsUserDepartments() {
			const ids = [];

			this.departments.forEach( department => {
				if ( department.users ) {
					department.users.forEach( user => {
						if ( user.id === this.authUserId ) {
							ids.push( department.id );
						}
					} );
				}
			} );

			return ids;
		},

		selectedDepartmentsUsers() {
			const users = [];

			this.selectedDepartments.forEach( department => {
				if ( Array.isArray( department.users ) ) {
					department.users.forEach( user => {
						users.push( user );
					} );
				}
			} );

			return users;
		},

		selectedDepartmentsUsersIds() {
			return this.selectedDepartmentsUsers.map( user => user.id );
		},

		someDepartmentsSelected() {
			return this.selectedDepartments.length > 0;
		},

		allDepartmentsSelected() {
			return this.selectedDepartments.length === this.departments.length;
		}
	},

	watch: {
		selectedDepartments( val ) {
			this.$emit( "updateDepartments", val );
		},

		selectedDepartmentsUsersIds( val ) {
			this.$emit( "updateUserIds", val );
		}
	},

	methods: {
		onChange( idsDepartments ) {
			localStorage.setItem(
				this.localStorageKeyName,
				JSON.stringify( idsDepartments )
			);
		},

		genDepartmentSelection( props ) {
			const chipProps = {
				light: true,
				label: true,
				small: true
			};

			if ( this.allDepartmentsSelected ) {
				if ( props.index === 0 ) {
					return <VChip
						attrs={chipProps}
						class={this.themeClasses}
						key="all-departments"
					>All Departments</VChip>;
				}
			} else if ( this.selectedDepartments.length > 1 ) {
				if ( props.index < this.maxChips ) {
					return <VChip
						attrs={chipProps}
						class={this.themeClasses}
						key={props.item.id}
					>{props.item.name}</VChip>;
				} else if ( props.index === this.maxChips ) {
					return <span class="text-caption" key="other">
						(+{this.numHiddenChips} {this.numHiddenChips === 1 ? "other" : "others"})
					</span>;
				}
			} else {
				return <VChip
					attrs={chipProps}
					class={this.themeClasses}
					key={props.item.id}
				>{props.item.name}</VChip>;
			}
		},

		async fetchDepartments() {
			this.departments = await Department
			.orderBy( "name" )
			.select( {
				users: [ "id" ]
			} )
			.include( "users" )
			.get();

			if ( localStorage.hasOwnProperty( this.localStorageKeyName ) ) {
				this.idsSelectedDepartments = JSON.parse(
					localStorage.getItem( this.localStorageKeyName )
				);
			} else if ( this.idsUserDepartments.length ) {
				this.idsSelectedDepartments = this.idsUserDepartments;
			} else {
				this.idsSelectedDepartments = this.departments.map( department => department.id );
			}
		},

		async fetch() {
			await this.fetchDepartments();
		}
	},

	render() {
		return <KSelectWithAll
			dark
			hideDetails
			itemText="name"
			itemValue="id"
			items={this.departments}
			label="Filter by Department"
			loading={this.$wait.is( "get departments" ) ? "white" : false}
			onChange={this.onChange}
			scopedSlots={{ selection: this.genDepartmentSelection }}
			selectAllText="All Departments"
			smallChips
			vModel={this.idsSelectedDepartments}
		></KSelectWithAll>;
	}
};
